webpackJsonp([59],{

/***/ 1353:
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(144)('meta');
var isObject = __webpack_require__(55);
var has = __webpack_require__(75);
var setDesc = __webpack_require__(54).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(76)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ 1356:
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(79);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ 1387:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(55);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),

/***/ 1420:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(54).f;
var create = __webpack_require__(240);
var redefineAll = __webpack_require__(247);
var ctx = __webpack_require__(64);
var anInstance = __webpack_require__(246);
var forOf = __webpack_require__(239);
var $iterDefine = __webpack_require__(150);
var step = __webpack_require__(251);
var setSpecies = __webpack_require__(252);
var DESCRIPTORS = __webpack_require__(40);
var fastKey = __webpack_require__(1353).fastKey;
var validate = __webpack_require__(1387);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),

/***/ 1421:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(17);
var $export = __webpack_require__(28);
var meta = __webpack_require__(1353);
var fails = __webpack_require__(76);
var hide = __webpack_require__(56);
var redefineAll = __webpack_require__(247);
var forOf = __webpack_require__(239);
var anInstance = __webpack_require__(246);
var isObject = __webpack_require__(55);
var setToStringTag = __webpack_require__(105);
var dP = __webpack_require__(54).f;
var each = __webpack_require__(1422)(0);
var DESCRIPTORS = __webpack_require__(40);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),

/***/ 1422:
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(64);
var IObject = __webpack_require__(149);
var toObject = __webpack_require__(78);
var toLength = __webpack_require__(106);
var asc = __webpack_require__(1423);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),

/***/ 1423:
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(1424);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),

/***/ 1424:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(55);
var isArray = __webpack_require__(1356);
var SPECIES = __webpack_require__(22)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ 1425:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(146);
var from = __webpack_require__(1426);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),

/***/ 1426:
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(239);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),

/***/ 1427:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(28);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),

/***/ 1428:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(28);
var aFunction = __webpack_require__(80);
var ctx = __webpack_require__(64);
var forOf = __webpack_require__(239);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),

/***/ 1577:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1616), __esModule: true };

/***/ }),

/***/ 1616:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(241);
__webpack_require__(143);
__webpack_require__(234);
__webpack_require__(1617);
__webpack_require__(1618);
__webpack_require__(1619);
__webpack_require__(1620);
module.exports = __webpack_require__(12).Map;


/***/ }),

/***/ 1617:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(1420);
var validate = __webpack_require__(1387);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(1421)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),

/***/ 1618:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(28);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(1425)('Map') });


/***/ }),

/***/ 1619:
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(1427)('Map');


/***/ }),

/***/ 1620:
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(1428)('Map');


/***/ }),

/***/ 2535:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__(1577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      formRules: {
        customerid: [{ required: true, message: '请选择客户', trigger: 'change' }],
        projectid: [{ required: true, message: '请选择项目', trigger: 'change' }]
      },
      selectedBatchIds: [],
      form: {
        id: null,
        customerid: null,
        customername: '',
        customernumber: '',
        projectid: null,
        projectname: '',
        projectnumber: '',
        status: 1,
        setting_config_json: {
          is_project_audit: 1,
          batch_audit_cfg: []
        }
      }
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      return vm.onLoad();
    });
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.onReload();
    next();
  },
  created: function created() {},

  watch: {
    // 多选组件可能是原地修改数组，deep 确保变更能触发联动逻辑
    selectedBatchIds: {
      deep: true,
      handler: function handler(val) {
        this.syncBatchAuditCfg(val);
      }
    },
    'form.setting_config_json.is_project_audit': {
      handler: function handler(val) {
        // 项目维度审单：允许不配置批次，但仍支持编辑批次选择
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, request.map(['getCustomerTable', 'getCustomerDetail', 'getBaiscProjectTable', 'getProjectDetail', 'getBatchTable', 'getBatchDetail', 'queryExamTaskTable', 'getExamTaskDetail']), {
    onLoad: function onLoad() {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id);
      }
    },
    onReload: function onReload() {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data());
      this.onLoad();
    },
    setForm: function setForm(id) {
      var _this = this;

      request.page('getAuditTaskSetting', { id: id }).then(function (_ref) {
        var data = _ref.data;

        filter.setLoop(_this.form, data);

        _this.form.customerid = String(_this.form.customerid);
        _this.form.projectid = String(_this.form.projectid);

        _this.selectedBatchIds = _this.form.setting_config_json.batch_audit_cfg.map(function (it) {
          return String(it.batchid);
        });
      });
    },
    onCustomerChanged: function onCustomerChanged(item) {
      // RemoteSelect change 回传选中对象；新建时用于补齐后端必填字段
      if (!item) {
        this.form.customername = '';
        this.form.customernumber = '';
        this.form.projectid = null;
        this.form.projectname = '';
        this.form.projectnumber = '';
        this.selectedBatchIds = [];
        this.form.setting_config_json.batch_audit_cfg = [];
        return;
      }
      this.form.customername = item.customername || item.name || '';
      this.form.customernumber = item.customernumber || item.number || '';

      // 切换客户后，项目与批次依赖客户，需要清空
      this.form.projectid = null;
      this.form.projectname = '';
      this.form.projectnumber = '';
      this.selectedBatchIds = [];
      this.form.setting_config_json.batch_audit_cfg = [];
    },
    onProjectChanged: function onProjectChanged(item) {
      if (!item) {
        this.form.projectname = '';
        this.form.projectnumber = '';
        this.selectedBatchIds = [];
        this.form.setting_config_json.batch_audit_cfg = [];
        return;
      }
      this.form.projectname = item.projectname || item.name || '';
      this.form.projectnumber = item.projectnumber || item.number || '';

      // 切换项目后，批次依赖项目，需要清空
      this.selectedBatchIds = [];
      this.form.setting_config_json.batch_audit_cfg = [];
    },
    onEnableExamTaskChange: function onEnableExamTaskChange(row) {
      var enabled = parseInt(row.enable_exam_task) === 1;
      if (!enabled) {
        row.exam_task_cfg_id = null;
      }
    },
    syncBatchAuditCfg: function syncBatchAuditCfg(batchIds) {
      var ids = (batchIds || []).map(function (id) {
        return parseInt(id);
      }).filter(function (id) {
        return !__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan___default()(id);
      });

      var existed = this.form.setting_config_json.batch_audit_cfg || [];
      var existedMap = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a(existed.map(function (r) {
        return [parseInt(r.batchid), r];
      }));

      var nextCfg = [];
      ids.forEach(function (batchid) {
        if (existedMap.has(batchid)) {
          nextCfg.push(existedMap.get(batchid));
        } else {
          nextCfg.push({
            batchid: batchid,
            enable_exam_task: 0,
            exam_task_cfg_id: null,
            enable_two_people: 0
          });
        }
      });

      nextCfg.forEach(function (row) {
        row.batchid = row.batchid === null || row.batchid === undefined ? null : parseInt(row.batchid);
        row.enable_exam_task = parseInt(row.enable_exam_task);
        row.enable_two_people = parseInt(row.enable_two_people);

        if (row.enable_exam_task !== 1) {
          row.exam_task_cfg_id = null;
        } else {
          row.exam_task_cfg_id = row.exam_task_cfg_id === null || row.exam_task_cfg_id === undefined || row.exam_task_cfg_id === '' ? null : parseInt(row.exam_task_cfg_id);
        }
      });

      this.form.setting_config_json.batch_audit_cfg = nextCfg;
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$refs.form.validate(function (valid) {
        if (!valid) {
          _this2.$message.error('提交内容填写不正确！');
          return;
        }
        var isProjectAudit = parseInt(_this2.form.setting_config_json.is_project_audit) === 1;
        if (!isProjectAudit && (!_this2.selectedBatchIds || _this2.selectedBatchIds.length === 0)) {
          _this2.$message.error('请至少选择一个批次');
          return;
        }

        var batchAuditCfg = (_this2.form.setting_config_json.batch_audit_cfg || []).map(function (row) {
          var enableExamTask = parseInt(row.enable_exam_task);
          var examTaskCfgId = enableExamTask === 1 ? row.exam_task_cfg_id === null || row.exam_task_cfg_id === undefined || row.exam_task_cfg_id === '' ? null : parseInt(row.exam_task_cfg_id) : null;

          if (enableExamTask === 1 && (examTaskCfgId === null || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan___default()(examTaskCfgId))) {
            _this2.$message.error('\u5F00\u542F\u91D1\u6807\u65F6 \u91D1\u6807\u914D\u7F6EID \u5FC5\u586B\uFF08\u6279\u6B21ID: ' + row.batchid + '\uFF09');
            return null;
          }

          return {
            batchid: parseInt(row.batchid),
            enable_exam_task: enableExamTask,
            exam_task_cfg_id: examTaskCfgId,
            enable_two_people: parseInt(row.enable_two_people)
          };
        });

        if (batchAuditCfg.some(function (x) {
          return x === null;
        })) {
          return;
        }

        var payload = {
          customerid: parseInt(_this2.form.customerid),
          customername: _this2.form.customername,
          customernumber: _this2.form.customernumber,
          projectid: parseInt(_this2.form.projectid),
          projectname: _this2.form.projectname,
          projectnumber: _this2.form.projectnumber,
          setting_config_json: {
            is_project_audit: parseInt(_this2.form.setting_config_json.is_project_audit),
            batch_audit_cfg: batchAuditCfg
          }
        };

        var apiName = _this2.form.id ? 'updateAuditTaskSetting' : 'createAuditTaskSetting';
        var submitData = _this2.form.id ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({ id: _this2.form.id }, payload) : payload;

        request.common(apiName, submitData).then(function () {
          _this2.$message.success(_this2.form.id ? '修改成功' : '创建成功');
          _this2.$router.push({ path: '/audit-task-setting/table' });
        });
      });
    }
  })
});

/***/ }),

/***/ 276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuditTaskSettingFormPage_vue__ = __webpack_require__(2535);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a8f68a7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuditTaskSettingFormPage_vue__ = __webpack_require__(3269);
function injectStyle (ssrContext) {
  __webpack_require__(3267)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuditTaskSettingFormPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a8f68a7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuditTaskSettingFormPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 3267:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3268);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("501c29ab", content, true, {});

/***/ }),

/***/ 3268:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".form-content-half .el-form-item__content{max-width:50%}.form-panel{margin:20px 0 0}", "", {"version":3,"sources":["/workspace/src/views/audit-task-setting/pages/AuditTaskSettingFormPage.vue"],"names":[],"mappings":"AACA,0CAA0C,aAAa,CACtD,AACD,YAAY,eAAe,CAC1B","file":"AuditTaskSettingFormPage.vue","sourcesContent":["\n.form-content-half .el-form-item__content{max-width:50%\n}\n.form-panel{margin:20px 0 0\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":"/audit-task-setting/table"}},[_vm._v("审单管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("审单系统配置")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("审单系统配置")]),_vm._v(" "),_c('el-form',{ref:"form",staticClass:"form-content-half",attrs:{"model":_vm.form,"rules":_vm.formRules,"size":"medium","label-width":"140px"}},[_c('el-form-item',{attrs:{"label":"客户","prop":"customerid"}},[_c('remote-select',{attrs:{"placeholder":"请输入客户名称/编号搜索","query-request":_vm.getCustomerTable,"find-request":_vm.getCustomerDetail,"disabled":!!_vm.form.id},on:{"change":_vm.onCustomerChanged},model:{value:(_vm.form.customerid),callback:function ($$v) {_vm.$set(_vm.form, "customerid", $$v)},expression:"form.customerid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目","prop":"projectid"}},[_c('remote-select',{attrs:{"placeholder":"请输入项目名称/编号搜索","disabled":!_vm.form.customerid || !!_vm.form.id,"query-request":_vm.getBaiscProjectTable,"query-params":{ customerid: _vm.form.customerid },"find-request":_vm.getProjectDetail},on:{"change":_vm.onProjectChanged},model:{value:(_vm.form.projectid),callback:function ($$v) {_vm.$set(_vm.form, "projectid", $$v)},expression:"form.projectid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"以项目维度审单"}},[_c('el-switch',{attrs:{"active-value":1,"inactive-value":0},model:{value:(_vm.form.setting_config_json.is_project_audit),callback:function ($$v) {_vm.$set(_vm.form.setting_config_json, "is_project_audit", $$v)},expression:"form.setting_config_json.is_project_audit"}})],1),_vm._v(" "),_c('el-divider'),_vm._v(" "),_c('el-form-item',{attrs:{"label":"批次选择"}},[_c('remote-select',{attrs:{"multiple":true,"multiple-limit":50,"placeholder":"请输入批次关键字","disabled":!_vm.form.projectid,"label-key":"detail","query-request":_vm.getBatchTable,"query-params":{ customerid: _vm.form.customerid, projectid: _vm.form.projectid },"find-request":_vm.getBatchDetail},model:{value:(_vm.selectedBatchIds),callback:function ($$v) {_vm.selectedBatchIds=$$v},expression:"selectedBatchIds"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"批次配置"}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.form.setting_config_json.batch_audit_cfg,"border":"","size":"mini"}},[_c('el-table-column',{attrs:{"prop":"batchid","label":"批次ID","min-width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"开启金标","min-width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-switch',{attrs:{"active-value":1,"inactive-value":0},on:{"change":function($event){return _vm.onEnableExamTaskChange(scope.row)}},model:{value:(scope.row.enable_exam_task),callback:function ($$v) {_vm.$set(scope.row, "enable_exam_task", $$v)},expression:"scope.row.enable_exam_task"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"金标配置ID","min-width":"220"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('remote-select',{staticStyle:{"width":"220px"},attrs:{"placeholder":"请选择金标","disabled":parseInt(scope.row.enable_exam_task) !== 1,"clearable":"","id-key":"id","label-key":"standard_order_id","value-key":"id","query-request":_vm.queryExamTaskTable,"query-params":{},"find-request":_vm.getExamTaskDetail},model:{value:(scope.row.exam_task_cfg_id),callback:function ($$v) {_vm.$set(scope.row, "exam_task_cfg_id", $$v)},expression:"scope.row.exam_task_cfg_id"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"开启2人审核","min-width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-switch',{attrs:{"active-value":1,"inactive-value":0},model:{value:(scope.row.enable_two_people),callback:function ($$v) {_vm.$set(scope.row, "enable_two_people", $$v)},expression:"scope.row.enable_two_people"}})]}}])})],1)],1),_vm._v(" "),_c('el-row',{staticClass:"form-panel"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onSubmit}},[_vm._v("保存\n        ")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.$router.back()}}},[_vm._v("返回")])],1)],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/audit-task-setting-form-create.a9aa19bbc0cbc208d6c1.js